import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ShowsApi, Configuration } from "manager-common";
import { useAuth } from "react-oidc-context";
import { useApiConfig } from "common-fe";
import { useTranslation } from "i18n-fe";

const MANAGER_API_BASE_URL = import.meta.env.VITE_MANAGER_API_BASE_URL;

export function useShow() {
  const { showId } = useParams();
  const auth = useAuth();
  const buildConfig = useApiConfig();
  const { t } = useTranslation("common");
  const [show, setShow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchShow = async () => {
      if (!auth.user?.access_token) {
        setError(t("shows.detail.authError"));
        setLoading(false);
        return;
      }

      try {
        const api = new ShowsApi(
          new Configuration(buildConfig(MANAGER_API_BASE_URL))
        );
        const { data } = await api.getShow(showId);
        setShow(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching show:", err);
        setError(t("shows.detail.error"));
      } finally {
        setLoading(false);
      }
    };

    fetchShow();
  }, [showId, auth.user, buildConfig, t]);

  return { show, loading, error };
}
